import { CHARTER_FLIGHT_DETAILS } from 'constants/charterFlight'
import { AIRLINE_CODE_LE } from 'constants/flight'
import { CHARTER } from 'constants/provider'

const MALDIVES_CHARTER_ROUTE = CHARTER_FLIGHT_DETAILS['melbourne-maldives']

function isMelbourneMaldivesRoute(departureAirport?: string, arrivalAirport?: string): boolean {
  const charterOrigin = MALDIVES_CHARTER_ROUTE.originAirport.airportCode
  const charterDestination = MALDIVES_CHARTER_ROUTE.destinationAirport.airportCode

  return (departureAirport === charterOrigin && arrivalAirport === charterDestination) ||
    (departureAirport === charterDestination && arrivalAirport === charterOrigin)
}

export function isMaldivesCharterJourney(journey: App.JourneyV2): boolean {
  if (journey.provider === CHARTER) return true

  const firstFlight = journey.flightGroup.flights[0]
  const lastFlight = journey.flightGroup.flights[journey.flightGroup.flights.length - 1]
  const hasLuxuryEscapesCarrier = journey.carrier === AIRLINE_CODE_LE ||
    journey.flightGroup.flights.some(flight => flight.marketingAirline.code === AIRLINE_CODE_LE)

  return hasLuxuryEscapesCarrier && isMelbourneMaldivesRoute(firstFlight?.departureAirport, lastFlight?.arrivalAirport)
}
